import { Instagram, ArrowRight, Heart, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

// Curated preview grid — replace srcs with real Instagram post images/screenshots later
const POSTS = [
  { img: "https://customer-assets.emergentagent.com/job_vikram-patna/artifacts/57uqp6iu_IMG-20260710-WA0012.jpg", caption: "Our centre in Rajeev Nagar. Home of every future topper.", likes: 128, comments: 14 },
  { img: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg", caption: "Class VIII students during weekly Science test.", likes: 96, comments: 8 },
  { img: "https://images.pexels.com/photos/3231358/pexels-photo-3231358.jpeg", caption: "Concept-first teaching in action.", likes: 142, comments: 19 },
  { img: "https://images.unsplash.com/photo-1551731409-43eb3e517a1a?crop=entropy&cs=srgb&fm=jpg&w=600&q=80", caption: "Doubt-solving Saturday — no question too small.", likes: 87, comments: 6 },
];

export default function InstagramSection() {
  return (
    <section className="py-20 lg:py-24 bg-white" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <span className="vk-chip">Follow us</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-800 tracking-tight text-[#0B192C]">
              Life at Vikramshila, on{" "}
              <span className="bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] bg-clip-text text-transparent">
                Instagram
              </span>
            </h2>
            <p className="mt-3 text-slate-600 text-lg">
              Behind-the-scenes from our classrooms, topper stories, exam tips and quick doubt sessions.
            </p>
          </div>
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-cta"
            className="inline-flex items-center gap-2 self-start text-white font-semibold px-5 py-3 rounded-lg transition-transform hover:scale-[1.02]"
            style={{ background: "linear-gradient(45deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%)" }}
          >
            <Instagram size={18} /> Follow @{BRAND.instagramHandle}
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {POSTS.map((p, i) => (
            <a
              key={i}
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid={`ig-post-${i}`}
              className="group relative aspect-square rounded-lg overflow-hidden border border-slate-200 block"
            >
              <img src={p.img} alt={p.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-between p-4">
                <div className="self-end">
                  <Instagram size={18} className="text-white drop-shadow" />
                </div>
                <div className="text-white">
                  <p className="text-xs line-clamp-2 mb-2">{p.caption}</p>
                  <div className="flex items-center gap-4 text-xs">
                    <span className="flex items-center gap-1"><Heart size={12} /> {p.likes}</span>
                    <span className="flex items-center gap-1"><MessageCircle size={12} /> {p.comments}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#DD2A7B] font-medium">
            View all posts on Instagram <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
